import React from 'react';

import leftArrow from './assets/ic_left_arrow.svg';
import rightArrow from './assets/ic_right_arrow.svg';
import NoActiveHurricaneImage from './assets/hurricane/ic_hurricanes_no active_map';
import styled from 'styled-components';
import { CurrentHurricane } from '../utilities/interfaces';

const noActiveHurricanes = 'NO ACTIVE HURRICANES';

interface HurricaneSelectorType {
    hurricanes: CurrentHurricane[];
    currentHurricaneIndex: number;
    selectHurricane: (newHurricaneId: string) => void;
    noHurricaneOrientation: string;
    noHurricaneImageWidth: number;
    noHurricaneImageHeight: number;
}

export const HurricaneSelector = ({
    hurricanes,
    currentHurricaneIndex,
    selectHurricane,
    noHurricaneOrientation,
    noHurricaneImageWidth,
    noHurricaneImageHeight
}: HurricaneSelectorType) => {

    const arrowClicked = (isRightArrow: boolean) => {
        const hurricanesLength = hurricanes.length;
        let newIndex = 0;
        if (isRightArrow) {
            if (currentHurricaneIndex + 1 < hurricanesLength) {
                newIndex = currentHurricaneIndex + 1;
            }
        } else {
            if (currentHurricaneIndex === 0) {
                newIndex = hurricanesLength - 1;
            } else {
                newIndex = currentHurricaneIndex - 1;
            }
        }

        const newHurricaneId = hurricanes[newIndex]?.id;
        selectHurricane(newHurricaneId);
    };

    const renderNoActiveHurricane = () => {
        return (
            <NoActiveHurricanesContainer>
                <NoActiveHurricanesImage>
                    <NoActiveHurricaneImage fillColor='#666666' width={noHurricaneImageWidth} height={noHurricaneImageHeight} />
                </NoActiveHurricanesImage>
                <span>{noActiveHurricanes}</span>
            </NoActiveHurricanesContainer>
        );
    };

    const currentHurricane = hurricanes?.[currentHurricaneIndex];
    const title = `${currentHurricane?.type} ${currentHurricane?.name}`;

    return !hurricanes || hurricanes?.length === 0 ? renderNoActiveHurricane()
        : <Container>
            <Title>
                <Arrow alt='Select hurricane left' src={leftArrow} onClick={() => arrowClicked(false)} />
                {title.toUpperCase()}
                <Arrow alt='Select hurricane right' src={rightArrow} onClick={() =>arrowClicked(true)} />
            </Title>
            <div>
                {hurricanes.map((hurricane, index) =>
                    <LargeDot key={hurricane?.id} index={index} currentHurricaneIndex={currentHurricaneIndex}>&#8226;</LargeDot>
                )}
            </div>
        </Container>;
};

const Container = styled.div`
    background-color: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    border-radius: '2px 2px 0px 0px';
    color: #666666;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-bottom: 1px solid #BCBBC1;
    font-size: 14px;
`;

const Title = styled.div`
    padding-top: 10px;
    font-weight: bold;
`;

const Arrow = styled.img`
    cursor: pointer;
    margin-left: 8px;
    margin-right: 8px;
`;

interface LargeDotProps {
    index: number;
    currentHurricaneIndex: number;
}
const LargeDot = styled.span<LargeDotProps>`
    font-size: 28px;
    line-height: 13px;
    color: ${({ index, currentHurricaneIndex }) => index === currentHurricaneIndex ? '#666666' : '#C2C2C2'};
`;

const NoActiveHurricanesImage = styled.div`
    padding: 8px;
`;

const NoActiveHurricanesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    justify-content: center;
    color: #555555;
    font-size: 16px;
    background-color: #FFFFFF;
    border-radius: 2px 2px 0px 0px;
    height: 100%;
`;
